import VInputNumber from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputNumber', VInputNumber),
};
